import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'Ab wann hat Finn eine Verbesserung gezeigt?',
  answer: 'Bereits nach 7–10 Tagen zeigte Finn deutliche Verbesserungen. Bei manchen Hunden dauert es etwas länger — bis zu 3 Wochen.'
}, {
  question: 'Ist das Topping auch für empfindliche Hunde geeignet?',
  answer: 'Ja — das Topping enthält keine Zusatzstoffe, keine künstlichen Aromen und ist speziell für Hunde mit empfindlichem Magen entwickelt.'
}, {
  question: 'Wie viel gibt man täglich?',
  answer: 'Die empfohlene Menge steht auf der Verpackung und richtet sich nach dem Körpergewicht des Hundes. Finns Besitzerin hat mit der kleinsten Menge angefangen und langsam gesteigert.'
}, {
  question: 'Was wenn es bei meinem Hund nicht wirkt?',
  answer: 'Hunderunde bietet eine Zufriedenheitsgarantie. Falls du keine Verbesserung siehst, kannst du dich direkt an den Kundenservice wenden.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full py-16 px-4" data-id="element-96">
      <div className="max-w-3xl mx-auto" data-id="element-97">
        <h2 className="font-handwriting text-4xl text-center text-forest font-bold mb-10" data-id="element-98">
          Häufige Fragen
        </h2>

        <div className="space-y-4" data-id="element-99">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-cream-card rounded-xl shadow-sm border border-brown/10 overflow-hidden" data-id="element-100">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-brown/5 transition-colors" data-id="element-101">
                <span className="font-serif font-bold text-gray-800 text-lg pr-4" data-id="element-102">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-forest flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-103" />
              </button>

              <AnimatePresence data-id="element-104">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-105">
                    <div className="px-6 pb-5 font-serif text-gray-700 leading-relaxed" data-id="element-106">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}